<template>
    <div class="diameter">
        <div class="menu">
            <el-form :inline="true" >
               <el-form-item label="选择支线">
                <el-select placeholder="请选择支线" v-model="pipelineId" @change="changePipelineId">
                    <el-option label="耕德电子站点侧支线" value="1"></el-option>
                    <el-option label="顶益400支线" value="2"></el-option>
                    <el-option label="娃哈哈200支线" value="3"></el-option>
                    <el-option label="味全食品支线" value="4"></el-option>
                    <el-option label="耕德电子测点间支线" value="5"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="开始时间">
                <!--日期-->
                <el-date-picker
                  v-model="start_time"
                  type="datetime"
                  class="start_date date-input"
                  placeholder="开始时间">
                </el-date-picker>
              </el-form-item>
      
              <el-form-item label="结束时间">
                <!--日期-->
                <el-date-picker
                  v-model="end_time"
                  type="datetime"
                  class="end_date date-input"
                  placeholder="结束时间">
                </el-date-picker>
              </el-form-item>

              <el-button plain type="primary" class="menu-btn" @click="createReport()">
                <span>生成报告</span>
              </el-button>

            </el-form>

        </div>
        <!--表格-->
        <el-table
        :data="reportDataTable"
        border
        class="report-table data-table"
        style="width: 100%"
        :header-cell-style="{
            background: 'rgba(78,132,255,1)',
            color: 'white',
            textAlign: 'center',
        }">
            <el-table-column
                prop="sectionId"
                label="管线编号"
                width="180">
            </el-table-column>
            <el-table-column
                prop="reportGenerateTime"
                label="报告生成时间"
                width="180">
            </el-table-column>
            <el-table-column
                prop="startTime"
                label="数据开始时间">
            </el-table-column>
            <el-table-column
                prop="endTime"
                label="数据结束时间">
            </el-table-column>
            <el-table-column
                prop="suggest"
                label="操作">
                <template slot-scope="scope">
                    <el-button
                    size="mini"
                    type="primary"
                    plain
                    @click="viewReport(scope.row)">查看报告</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--分页-->
        <el-pagination v-if="page.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.current"
            :page-sizes="[10, 20, 30, 40,100]"
            :page-size="page.size"
            layout="prev, pager, next, jumper,sizes,total"
            :total="page.total">
        </el-pagination>

        <!--分析报告-->
        <el-dialog
            :visible.sync="reportDialog"
            append-to-body
            custom-class="report-dialog">
            <span slot="title">{{diameterDetail.title}}</span>
            <diameter-detail :detail="diameterDetail"></diameter-detail>
        </el-dialog>
    </div>
</template>
<script>
import {getPipeHeatAnalysis,createReport} from "@api/decision"
import DiameterDetail from "./component/DiameterDetail"

export default {
    name:"diameter",
    data(){
        return {
            start_time:'', //开始时间
            end_time:'', // 结束时间
            pipelineId:"1", //管线编号
            reportDataTable:[], // 分析报个表格数据

            page:{ // 分页参数
                total:0,
                size:10,
                current:1
            },

            reportDialog:false , // 分析报个弹出框
            reportContentHtml:"内容为空", // 分析报告的内容
            diameterDetail:"", //管径分析报告内容
        }
    },
    components:{
        'diameter-detail':DiameterDetail
    },
    mounted(){
        // 获取当前时间，并格式化
        let now=new Date();
        let nowObj=this.$moment(now);
        this.end_time=nowObj.format("yyyy-MM-DD HH:mm:ss");
        this.start_time=nowObj.add(-1,'days').format("yyyy-MM-DD HH:mm:ss");

        // 请求报告数据
        this.getPipeHeatAnalysis(1,10);
    },
    methods:{
        // 获取报告数据
        getPipeHeatAnalysis(page,size){
            page=page||this.page.current;
            size=size||this.page.size;
            getPipeHeatAnalysis(this.pipelineId,page,size).then(res=>{
                // 设置数据
                if(res.status&&res.status==200){
                    let resdata=res.content;

                    // 设置数据
                    this.reportDataTable=resdata.content;

                    // 设置分页
                    let tempPage={};
                    tempPage.current=resdata.number+1;
                    tempPage.size=resdata.size;
                    tempPage.total=resdata.totalElements;
                    this.page=tempPage;
                }
            })
        },
        // 页码改变
        handleCurrentChange(val){
            this.getPipeHeatAnalysis(val,"");
        },
        // 分页大小改变
        handleSizeChange(val){
            this.getPipeHeatAnalysis("",val);
        },
        // 查看报告
        viewReport(row){
            // 打开分析报告弹出框
            this.reportDialog=true;
            // 设置显示的内容
            this.diameterDetail=JSON.parse(row.results);
        },
        // 生成报告
        createReport(){
            // 对时间进行格式化
            let start_time=this.$moment(this.start_time).format("yyyy-MM-DD HH:mm:ss");
            let end_time=this.$moment(this.end_time).format("yyyy-MM-DD HH:mm:ss");

            createReport(this.pipelineId,start_time,end_time,"diameter").then(res=>{
                if(res.status&&res.status==200){
                    this.diameterDetail=res.content[0].results;
                    this.reportDialog=true;

                    // 重新查询生成列表
                    this.getPipeHeatAnalysis();
                }
            })
        },
        // 管线编号改变
        changePipelineId(val){
            this.pipelineId=val;
            this.getPipeHeatAnalysis(1,10);
        }
        
    }
    
    
}
</script>
<style lang="scss">
.diameter{
    padding:10px;

    button{
        cursor: pointer;
        span{
            cursor: pointer;
        }
    }

    .data-table{
        td,th{
            text-align: center !important;
        }
    }
    .el-pagination{
        float:right;
    }
}
/** 详情弹窗 */
.report-dialog{
    width: auto;
    position: absolute;
    bottom: 20px;
    right: 20px;
    left: 20px;
    top: 20px;
    overflow: auto;
    margin: initial !important;

    .el-dialog__header{
        font-size: 16px;
        padding: 10px 5px 0px 5px;
        text-align: center;
        font-weight: 600;
    }
    .el-dialog__headerbtn{
        right: 10px;
        top: 5px;
        font-size: 25px;
    }
    .el-dialog__body{
        padding:10px;

        p{
            text-indent: 2em;
            padding: 0px;
            margin: 0px;
            margin: 10px 0;
            font-size: 15px;
        }
    }
}
</style>